import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ["dropdown_input", "clear_button"],
      allowEmptyOption: true,
      valueField: "id",
      labelField: "text",
      searchField: "text",
      loadThrottle: 400,
      load: (query, callback) => this.load(query, callback)
    })
  }

  disconnect() {
    this.select?.destroy()
  }

  async load(query, callback) {
    if (query.trim().length < 3) return callback()

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("query", query)
      const response = await fetch(url, {headers: {Accept: "application/json"}})
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      callback(await response.json())
    } catch (error) {
      console.error("[remote-tom-select] Unable to load options", error)
      callback()
    }
  }
}
